<template>
<b-card header="Edit manager form">

  <b-form id="initmanager-form">

    <b-row>
      <b-col sm="12" lg="6">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Phonenumber</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-model="formData.phone" placeholder="Phone" :disabled="true"></b-form-input>
            <b-input-group-append>
              <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col sm="12" lg="6">
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>Email</b-input-group-text>
            </b-input-group-prepend>
            <b-form-input type="text" v-model="formData.email" placeholder="Email" :disabled="true"></b-form-input>
            <b-input-group-append>
              <b-input-group-text><i class="fa fa-at"></i></b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>Start</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="date" id="startDate" v-model="formData.startDate" placeholder="StartDate"></b-form-input>
        <b-form-input type="time" id="startTime" v-model="formData.startTime"></b-form-input>
        <b-input-group-append>
          <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>End</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="date" id="endDate" v-model="formData.endDate" placeholder="EndDate"></b-form-input>
        <b-form-input type="time" id="endTime" v-model="formData.endTime"></b-form-input>
        <b-input-group-append>
          <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>Notes</b-input-group-text>
        </b-input-group-prepend>
        <b-form-textarea :rows="3" :max-rows="6" id="description" v-model="formData.notes" placeholder="Notes" :value="Notes"></b-form-textarea>
        <b-input-group-append>
          <b-input-group-text><i class="fa fa-sticky-note-o"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <div class="form-group form-actions">
      <b-button @click="submitDataManager($event.target)" type="button" size="sm" variant="primary">Save</b-button>
    </div>
  </b-form>
</b-card>
</template>

<script>

let qs = require('qs')
const constants = require('../shared/constants')
// import getToday from '../shared/constants'
// import getEndDate from '../shared/constants'
// import getTimeNow from '../shared/constants'
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockManagers/detail'
const API_LIST = BASE + '/api/lockManagers/list'
const API_EDIT = BASE + '/api/lockManagers/edit'

function postdata (url, data) {
  let partsStartDate = data.startDate.split('-')
  let partsEndDate = data.endDate.split('-')
  var partEndTime = data.endTime.split(':')
  var partStartTime = data.startTime.split(':')
  data.endDate = new Date(partsEndDate[0], partsEndDate[1] - 1, partsEndDate[2], partEndTime[0], partEndTime[1]).getTime()
  data.startDate = new Date(partsStartDate[0], partsStartDate[1] - 1, partsStartDate[2], partStartTime[0], partStartTime[1]).getTime()
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  })
    .then(res => res.json())
}

function postdatadetail (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getData (managerId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    managerId: managerId
  }
  let res = await postdatadetail(API, parameters)
  return res
}

async function getManagers () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token')
  }
  let res = await postdatadetail(API_LIST, parameters)
  return res.lockManagers
}

export default {
  name: 'manager-edit-form',
  data () {
    // var now = new Date()
    // var hour =  (now.getHours() < 10) ? '0' + now.getHours() : now.getHours()
    // var min = (now.getMinutes() < 10) ? '0' + now.getMinutes() : now.getMinutes()
    // var timeNow = hour + ':' + min
    return {
      manager: {},
      lockManager: {},
      formData: {
        managerId: '',
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: '',
        lockGroupId: '',
        email: '',
        phone: '',
        userName: '',
        addDate: '',
        endDate: '',
        startDate: '',
        startTime: '',
        endTime: '',
        notes: ''
      }
    }
  },
  props: ['managerId', 'modalId'],
  mounted () {
    getData(this.managerId).then(response => {
      this.$data.manager = response.manager
      this.$data.lockManager = response.lockManager
      this.$data.formData.name = this.$data.manager.user.name
      this.$data.formData.email = this.$data.manager.user.email
      this.$data.formData.phone = this.$data.manager.user.phone
      this.$data.formData.userName = this.$data.manager.user.phone
      this.$data.formData.managerId = this.$data.manager.lockManager.id
      this.$data.formData.notes = this.$data.manager.lockManager.notes
    })
    this.$data.formData.startDate = constants.getToday()
    this.$data.formData.addDate = constants.getToday()
    this.$data.formData.endDate = constants.getEndDate()
    this.$data.formData.startTime = constants.getTimeNow()
    this.$data.formData.endTime = constants.getTimeNow()
  },
  methods: {
    submitDataManager (button) {
      postdata(API_EDIT, this.formData)
        .then(data => {
          getManagers().then(dataList => {
            let modalIdFromList = this.modalId
            this.$root.$emit('managers', dataList)
            this.formData.startdate = constants.getToday()
            this.formData.enddate = constants.getEndDate()
            this.formData.startTime = constants.getTimeNow()
            this.formData.endTime = constants.getTimeNow()
            this.$root.$emit('bv::hide::modal', modalIdFromList, button)
          })
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
      location.reload()
    },
    onReset (evt) {
      evt.preventDefault()
      this.formData.lockId = ''
      this.formData.managerId = ''
      this.formData.locationId = ''
      this.formData.addDate = constants.getToday()
      this.formData.startDate = constants.getToday()
      this.formData.endDate = constants.getEndDate()
      this.formData.startTime = constants.getTimeNow()
      this.formData.endTime = constants.getTimeNow()
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    getDateFormated (aDate) {
      var someDate = new Date(aDate)
      var dd = String(someDate.getDate())
      var mm = String(someDate.getMonth())
      var yyyyNow = someDate.getFullYear()
      if (mm.length < 2) mm = '0' + mm
      if (dd.length < 2) dd = '0' + dd
      var someDateFormatted = yyyyNow + '-' + mm + '-' + dd
      return someDateFormatted
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          alert('From Submitted!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/ManagerEditForm.vue